import { HOUSE_RULE_DEFINITIONS } from '../constants/house-rules.js';
export const HOUSE_RULE_DESCRIPTIONS = Object.fromEntries(HOUSE_RULE_DEFINITIONS.map(d => [d.key, d.description]));
//# sourceMappingURL=rule-descriptions.js.map